import { useMemo } from "react";
import { useContext, useEffect, useCallback } from "react";
import { SportsCampsContext } from "../context/sportscamps-context";
import { CategoryFilterRow } from "./CategoryFilterParts/CategoryFilterRow";

const CategoryFilter = () => {
	const {
		categories,
		setCategories,
		pageId,
		categoryButtonsActive,
		setCategoryButtonsActive,
		initCategoryButtonsActive,
		setInitCategoryButtonsActive,
		activityTypeSearchTermCodes,
		setActivityTypeSearchTermCodes,
	} = useContext(SportsCampsContext);

	// Retrieve sportsCamps categories
	// Local
	//const categoriesUrl = `https://localhost:44360/umbraco/api/sportscamps/GetSportsCampsCategories?pageId=${pageId}`;
	// Build
	const categoriesUrl = `/umbraco/api/sportscamps/GetSportsCampsCategories?pageId=${pageId}`;

	const fetchCategories = useCallback(async () => {
		try {
			const response = await fetch(categoriesUrl);

			if (!response.ok) {
				throw new Error("Something went wrong...");
			}

			const data = await response.json();

			setCategoryButtonsActive(Array(data.categories.length).fill(false));
			return setCategories(data);
		} catch (error) {
			console.log(error);
		}
	}, [categoriesUrl, setCategories, setCategoryButtonsActive]);

	useEffect(() => {
		fetchCategories();
	}, [fetchCategories]);

	const handleChange = (index, name) => {
		let copy = [...categoryButtonsActive];
		let current = copy[index];
		current = !current;
		copy[index] = current;
		setInitCategoryButtonsActive(false);
		setCategoryButtonsActive(copy);

		// Highlight all icons again if no single icons are selected
		if (copy.every((value) => value === false)) {
			setInitCategoryButtonsActive(true);
		}

		// Logic for setting separate icons active
		if (current === true) {
			setActivityTypeSearchTermCodes([
				...activityTypeSearchTermCodes,
				name,
			]);
		} else if (current === false) {
			setActivityTypeSearchTermCodes(
				activityTypeSearchTermCodes.filter(
					(item) => item !== name
				)
			);
		}
	};

	const Rows = useMemo(() => {
		if (categories && categories.categories) {
			return categories.categories.map((category, index) => (
				<CategoryFilterRow
					category={category}
					index={index}
					categoryButtonsActive={categoryButtonsActive}
					handleChange={handleChange}
					initCategoryButtonsActive={initCategoryButtonsActive} />
			));
		}
	}, [categories, categoryButtonsActive, handleChange, initCategoryButtonsActive]);

	return (
		<div className="sportscampscategory__filter">
			<div className="filter-content">
				<ul className="u-clear">
					{categories.categories && Rows}
				</ul>
			</div>
		</div>
	);
};

export default CategoryFilter;
